import { useState } from "react";
import { usePingPrintDriverServer } from "./api/queries/usePrint";
import { useLabelPrintMutation } from "./api/mutations/usePrint";

// Separate storage keys from the receipt printer (default-LB-printer /
// use-LB-printer-config) since the label printer is very likely a
// different physical device. use-LB-label-printer-config defaults to
// false (unlike the receipt toggle, which defaults true) — label printing
// via the agent is opt-in, so any merchant who hasn't configured it yet
// keeps today's browser-print-dialog behavior unchanged.
export const useLabelPrint = () => {
  const [defaultLabelPrinter] = useState(
    localStorage.getItem("default-LB-label-printer")
      ? JSON.parse(localStorage.getItem("default-LB-label-printer"))
      : null,
  );
  const [useLabelConfig] = useState(
    localStorage.getItem("use-LB-label-printer-config")
      ? JSON.parse(localStorage.getItem("use-LB-label-printer-config"))
      : false,
  );

  const { pingServer } = usePingPrintDriverServer();
  const { mutate: printLabelViaServer } = useLabelPrintMutation();

  // Checked once per print job (not per label) — callers that need to
  // print several labels in a row should call this once up front and
  // branch, rather than re-pinging for every individual label.
  const isLabelAgentReady = async () => {
    if (!useLabelConfig || !defaultLabelPrinter?.name) return false;
    return pingServer();
  };

  // Sends a single already-captured label image straight to the agent —
  // no readiness check here, callers decide that via isLabelAgentReady().
  const printLabel = ({
    imageData,
    onSuccess = () => {},
    onError = () => {},
  }) => {
    printLabelViaServer(
      { imageData, printerName: defaultLabelPrinter?.name },
      {
        onSuccess: () => onSuccess(),
        onError: () => onError(),
      },
    );
  };

  return {
    labelPrinterInfo: defaultLabelPrinter || null,
    useLabelConfig,
    isLabelAgentReady,
    printLabel,
  };
};

export default useLabelPrint;
